const actions = {
  LOGIN_BEGIN: 'LOGIN_BEGIN',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERR: 'LOGIN_ERR',

  LOGOUT_BEGIN: 'LOGOUT_BEGIN',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  LOGOUT_ERR: 'LOGOUT_ERR',

  LOGIN_PASSWORD_TIME: 'LOGIN_PASSWORD_TIME',
  LOGIN_PASSWORD_TIME_RES: 'LOGIN_PASSWORD_TIME_RES',

  loginPasswordTime: (dataPassword) => {
    return {
      type: actions.LOGIN_PASSWORD_TIME,
      payload: {
        dataPassword,
      },
    };
  },

  loginPasswordTimeRes: () => {
    return {
      type: actions.LOGIN_PASSWORD_TIME_RES,
      payload: {
        dataPassword: null,
      },
    };
  },

  loginBegin: () => {
    return {
      type: actions.LOGIN_BEGIN,
    };
  },

  loginSuccess: (isLoggedIn, userData) => {
    return {
      type: actions.LOGIN_SUCCESS,
      payload: {
        isLoggedIn,
        userData,
      },
    };
  },

  loginErr: (err) => {
    return {
      type: actions.LOGIN_ERR,
      err,
    };
  },

  logoutBegin: () => {
    return {
      type: actions.LOGOUT_BEGIN,
    };
  },

  logoutSuccess: (isLoggedIn, userData, updateUserDetail) => {
    return {
      type: actions.LOGOUT_SUCCESS,
      payload: {
        isLoggedIn,
        userData,
        updateUserDetail,
      },
    };
  },

  logoutErr: (err) => {
    return {
      type: actions.LOGOUT_ERR,
      err,
    };
  },
};

export default actions;
